import * as S from './styles'
import { useCasePage } from './useCasePage'
import { Image, Text } from '@/components'
import { useIsVisibleElement } from '@/hooks'
import { Hero } from '@/service/api/casePage'

export type CasePageHeroContainerProps = {
  data: Hero
  color: string
}
export const CasePageHeroContainer: React.FC<CasePageHeroContainerProps> = ({
  data,
  color,
}) => {
  const { fontSizes } = useCasePage()
  const { element, elementVisible } = useIsVisibleElement()
  return (
    <S.CasePageContainer color={color} elementVisible={elementVisible}>
      <div className="left-container ">
        <Image
          src={data.logo.url}
          alt={data.logo.alternativeText}
          fileName={data.logo.name}
          defaultSize={{
            height: data.logo.height,
            width: data.logo.width,
          }}
        />
        <Text size={fontSizes.title} color="darkgray">
          {data.title}
        </Text>
        <Text size={fontSizes.description} color="darkgray">
          {data.description}
        </Text>
      </div>
      {data.topics.length > 0 && (
        <div className="right-container">
          {data.topics.map((topic) => (
            <div key={topic.title} className="topic-container" ref={element}>
              <Text
                size={fontSizes.topicTitle}
                color="darkgray"
                className="topic-title"
              >
                {topic.title}
                <span className="bar" />
              </Text>
              {topic.subtopics.map((subtopic) => (
                <Text
                  key={subtopic.title}
                  className="subtopic-title"
                  size={fontSizes.subTopicTitle}
                  color="darkgray"
                >
                  {subtopic.title}
                </Text>
              ))}
            </div>
          ))}
        </div>
      )}
    </S.CasePageContainer>
  )
}
